module.exports = __webpack_public_path__ + "static/media/event-calendar-highlight-admin-icon.39629d5f.svg";